<template>
  <app-page labelledby="finance-policy-title">
    <page-header
      title-id="finance-policy-title"
      title="Учетная политика"
      description="Настройки правил бухгалтерского и налогового учета."
    />
    <app-state
      state="unavailable"
      title="Раздел пока недоступен"
      message="Настройка учетной политики еще не подключена. Используйте доступные настройки бухгалтерии."
      action-label="К настройкам бухгалтерии"
      :action-to="{ name: 'org_profile_buh_automatic' }"
    />
  </app-page>
</template>

<script>
import { AppPage, AppState, PageHeader } from '../../components/ui'

export default {
  name: 'finance_policy',
  components: { AppPage, AppState, PageHeader }
}
</script>
